export default "__VITE_ASSET__B3WuGsb6__"